import { render, staticRenderFns } from "./MergeConversation.vue?vue&type=template&id=59e0fa36&scoped=true&"
import script from "./MergeConversation.vue?vue&type=script&lang=js&"
export * from "./MergeConversation.vue?vue&type=script&lang=js&"
import style0 from "./MergeConversation.vue?vue&type=style&index=0&id=59e0fa36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e0fa36",
  null
  
)

export default component.exports